export const SORT_DESC = 'DESC';
export const SORT_ASC = 'ASC';

export const DEFAULT = 'default';
export const DATE = 'date';
export const NAME = 'name';
export const TRENDING = 'trending';

export const SORT_BY_DEFAULT = {
  label: 'Default',
  value: DEFAULT,
};

export const SORT_BY_DATE = {
  label: 'Date',
  value: DATE,
};

export const SORT_BY_NAME = {
  label: 'Name',
  value: NAME,
};

export const SORT_BY_TRENDING = {
  label: 'Trending',
  value: TRENDING,
};
